export default __webpack_public_path__ + "static/media/split-costs.40526342.png";